export enum QuickLinkItemContent {
    IconTitleDescription = 10,
    IconTitle = 20,
    Icon = 30,
}
